import { clsx, type ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

const florisoftTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // Custom text tokens are font sizes, not text colors. Keep them in
      // Tailwind Merge's font-size group so semantic color utilities survive.
      "font-size": [
        {
          text: [
            "ui-10",
            "ui-12",
            "ui-14",
            "ui-16",
            "ui-20",
            "ui-28",
            "heading-0",
            "heading-1",
            "heading-2",
            "heading-3",
            "heading-4",
            "heading-5",
            "heading-6",
          ],
        },
      ],
      // The motion tokens, as utilities in motion.css and theme easings.
      duration: [{ duration: ["fast", "normal", "slow", "slower"] }],
      ease: [{ ease: ["standard", "enter", "exit"] }],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return florisoftTwMerge(clsx(inputs))
}
